import {Component, ViewChild} from "@angular/core";
import {Router} from "@angular/router";
import {DataTableDirectives} from "angular2-datatable/datatable";
import {FORM_DIRECTIVES, FORM_PROVIDERS, FormControl, FormGroup, REACTIVE_FORM_DIRECTIVES} from "@angular/forms";
import {AlertComponent, BS_VIEW_PROVIDERS, MODAL_DIRECTIVES, ModalDirective} from "ng2-bootstrap/ng2-bootstrap";
import {PaginatePipe, PaginationControlsCmp, PaginationService} from "ng2-pagination";
import {Bank} from "../../domain/bank";
import {Page} from "../../domain/page";
import {BankService} from "../../service/bank.service";
import {MailTemplate} from "../../domain/mailTemplate";
import {MailTemplateService} from "../../service/mailTemplate.service";
import {ActionTrigger} from "../../domain/actionTrigger";
import {ActionTriggerService} from "../../service/actionTrigger.service";

/**
 * .
 * Created by jlado on 13/9/16.
 */
@Component({
    selector: 'config-mailTemplates',
    template: require('./config.mailTemplates.component.html'),
    styles: [require('./config.mailTemplates.component.css')],
    directives: [
        DataTableDirectives,
        FORM_DIRECTIVES,
        REACTIVE_FORM_DIRECTIVES,
        AlertComponent,
        MODAL_DIRECTIVES,
        PaginationControlsCmp
    ],
    providers: [
        FORM_PROVIDERS,
        PaginationService
    ],
    viewProviders: [BS_VIEW_PROVIDERS],
    pipes: [PaginatePipe],
})
export class ConfigMailTemplatesComponent {

    @ViewChild('bodyMailModal') bodyMailModal: ModalDirective;

    private data: MailTemplate[];

    private filter: MailTemplate;

    public banks: Bank[];
    public actionTriggers: ActionTrigger[];

    public error: any;

    private currentPage: Page;

    public form: FormGroup;

    public itemsPerPage: number;
    public loading: boolean;
    public page: number;
    public total: number;

    public mailTemplateSelected: MailTemplate;
    public bankTodos: Bank;
    public actionTriggerTodos: ActionTrigger;

    public mailTemplateTraduced: string;

    constructor(private router: Router,
                private mailTemplateService: MailTemplateService,
                private actionTriggerService: ActionTriggerService,
                private bankService: BankService) {

        this.init();

        bankService.getBanks().subscribe(
            this.setBanks.bind(this),
            () => {
                this.bindError('Ocurrió un error al cargar los bancos.');
            });

        actionTriggerService.getActionTriggers().subscribe(
            this.setActionTriggers.bind(this),
            () => {
                this.bindError('Ocurrió un error al cargar las acciones disparadoras.');
            });

        this.form.valueChanges
            .debounceTime(400)
            .subscribe(this.find.bind(this));

        /*Default: mostrar todos los templates de mail*/
        this.find();
    }

    private init(): void {
        this.data = [];

        this.banks = [];
        this.actionTriggers = [];

        this.itemsPerPage = 10;
        this.loading = false;
        this.page = 1;
        this.total = 0;

        this.bankTodos = new Bank();
        this.bankTodos.id = '';
        this.bankTodos.name = 'TODOS';

        this.actionTriggerTodos = new ActionTrigger();
        this.actionTriggerTodos.id = '';
        this.actionTriggerTodos.description = 'TODOS';

        this.filter = new MailTemplate();
        this.form = new FormGroup({
            actionTrigger: new FormControl(),
            bank: new FormControl(),
            itemsPerPage: new FormControl()
        });

        this.filter.bank = this.bankTodos;
        this.filter.action = this.actionTriggerTodos;
    }

    private setBanks(banks: Bank[]): void {
        this.banks = banks;
        if (banks.length == 1) {
            this.filter.bank = banks[0];
        }
    }

    private setActionTriggers(actionTriggers: ActionTrigger[]): void {
        this.actionTriggers = actionTriggers;
        if (actionTriggers.length == 1) {
            this.filter.action = actionTriggers[0];
        }
    }

    public find(): void {
        this.getData(1);
    }

    public filterEmpty(): boolean {
        return !(this.filter.bank.id != '' || this.filter.action.id != '');
    }

    private getData(page: number): void {
        this.error = null;
        //if (!this.filterEmpty()) {
        this.loading = true;
        this.mailTemplateService.findMailTemplates(this.filter, page, this.itemsPerPage).subscribe(
            (data) => {
                this.refreshData(data);
                this.page = page;
            },
            () => {
                this.bindError('Ocurrió un error al buscar los correos.');
            });
        //}
    }

    private refreshData(page: Page): void {
        this.data = page.content;
        this.currentPage = page;
        this.total = page.totalElements;
        this.loading = false;
    }

    public removeItem(deleteModal: any): void {
        this.error = null;
        this.mailTemplateService.delete(this.mailTemplateSelected.id).subscribe(
            () => {
                deleteModal.hide();
                this.removeItemFromView(this.mailTemplateSelected);
            },
            () => {
                this.bindError('Ocurrió un error al eliminar el correo.');
            });
    }

    private removeItemFromView(mailTemplate: MailTemplate): void {
        let index = this.data.indexOf(mailTemplate);
        if (index > -1) {
            this.data.splice(index, 1);
        }
        this.mailTemplateSelected = null;
    }

    public editItem(mailTemplate: MailTemplate): void {
        this.router.navigate(['app/home/editMailTemplate', mailTemplate.id]);
    }

    public createMailTemplate(): void {
        this.router.navigate(['app/home/createMailTemplate']);
    }

    public getPage(page: number): void {
        this.getData(page);
    }

    private bindError(messageError: string): void {
        this.loading = false;
        if (this.error == null) {
            this.error = messageError;
        } else {
            this.error = this.error.toString() + ' ' + messageError;
        }
    }

    public createPreviewMailTemplate(templateBody: string): void {
        this.loading = true;

        if (templateBody.length == 0) {
            templateBody = "VACÍO."
        }

        this.mailTemplateService.previewMailTemplate(templateBody).subscribe(
            (mailTemplateTraduced: MailTemplate) => {
                this.loading = false;
                this.mailTemplateTraduced = mailTemplateTraduced.templateBody.toString();
                this.bodyMailModal.show();
            },
            () => {
                this.bindError('Ocurrió un error al generar la vista previa.');
                this.loading = false;
            });
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/config/mailConfig/config.mailTemplates.component.ts
 **/